var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content_wrapper"
  }, [_c('agent-info'), _c('div', {
    ref: "save",
    staticClass: "contract_content"
  }, [_c('w-9-form-sidebar'), _c('div', {
    staticClass: "right_container"
  }, [_c('h3', [_vm._v("General Instruction")]), _c('div', {
    staticClass: "description"
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-1",
      modifiers: {
        "accordion-1": true
      }
    }],
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    },
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Introduction "), _vm.isVisible ? _c('strong', {
    staticClass: "ml-auto",
    staticStyle: {
      "position": "absolute",
      "right": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("-")]) : _c('strong', {
    staticClass: "ml-auto",
    staticStyle: {
      "position": "absolute",
      "right": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("+")])])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-1",
      "accordion": "my-accordion",
      "role": "tabpanel",
      "visible": ""
    }
  }, [_c('b-card-body', [_c('b-card-text', [_c('p', [_vm._v(" Section references are to the Internal Revenue Code unless otherwise noted. "), _c('b', [_vm._v("Future developments.")]), _vm._v(" For the latest information about developments related to Form W-9 and its instructions, such as legislation enacted after they were published, go to www.irs.gov/FormW9.")])])], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    },
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Purpose of Form ")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-2",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('b-card-text', {
    staticStyle: {
      "height": "190px",
      "overflow-y": "scroll"
    }
  }, [_c('h2', [_vm._v("Purpose of Form")]), _c('p', [_vm._v("An individual or entity (Form W-9 requester) who is required to file an information return with the IRS must obtain your correct taxpayer identification number (TIN) which may be your social security number (SSN), individual taxpayer identification number (ITIN), adoption taxpayer identification number (ATIN), or employer identification number (EIN), to report on an information return the amount paid to you, or other amount reportable on an information return. Examples of information returns include, but are not limited to, the following.")]), _c('ul', [_c('li', [_vm._v(" Form 1099-INT (interest earned or paid)")]), _c('li', [_vm._v("Form 1099-DIV (dividends, including those from stocks or mutual funds) ")]), _c('li', [_vm._v("Form 1099-MISC (various types of income, prizes, awards, or gross proceeds) ")]), _c('li', [_vm._v("Form 1099-B (stock or mutual fund sales and certain other transactions by brokers) ")]), _c('li', [_vm._v("Form 1099-S (proceeds from real estate transactions) ")]), _c('li', [_vm._v("Form 1099-K (merchant card and third party network transactions) ")]), _c('li', [_vm._v("Form 1098 (home mortgage interest), 1098-E (student loan interest), 1098-T (tuition) ")]), _c('li', [_vm._v("Form 1099-C (canceled debt) ")]), _c('li', [_vm._v("Form 1099-A (acquisition or abandonment of secured property) ")])]), _c('p', [_vm._v("Use Form W-9 only if you are a U.S. person (including a resident alien), to provide your correct TIN.")]), _c('p', [_c('i', [_vm._v("If you do not return Form W-9 to the requester with a TIN, you might be subject to backup withholding. See What is backup withholding, later.")])]), _c('p', [_vm._v("By signing the filled-out form, you: "), _c('ol', [_c('li', [_vm._v("Certify that the TIN you are giving is correct (or you are waiting for a number to be issued), ")]), _c('li', [_vm._v("Certify that you are not subject to backup withholding, or")]), _c('li', [_vm._v("Claim exemption from backup withholding if you are a U.S. exempt payee. If applicable, you are also certifying that as a U.S. person, your allocable share of any partnership income from a U.S. trade or business is not subject to the withholding tax on foreign partners' share of effectively connected income, and")]), _c('li', [_vm._v("Certify that FATCA code(s) entered on this form (if any) indicating that you are exempt from the FATCA reporting, is correct. See What is FATCA reporting, later, for further information.")])]), _c('span', {
    staticStyle: {
      "color": "#0594b8"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" If you are a U.S. person and a requester gives you a form other than Form W-9 to request your TIN, you must use the requester’s form if it is substantially similar to this Form W-9. ")]), _c('br'), _c('b', [_vm._v("Definition of a U.S. person.")]), _vm._v(" For federal tax purposes, you are considered a U.S. person if you are: "), _c('ul', [_c('li', [_vm._v("An individual who is a U.S. citizen or U.S. resident alien;")]), _c('li', [_vm._v("A partnership, corporation, company, or association created or organized in the United States or under the laws of the United States;")]), _c('li', [_vm._v("An estate (other than a foreign estate); or")]), _c('li', [_vm._v("A domestic trust (as defined in Regulations section 301.7701-7).")])]), _c('b', [_vm._v("Special rules for partnerships.")]), _vm._v(" Partnerships that conduct a trade or business in the United States are generally required to pay a withholding tax under section 1446 on any foreign partners’ share of effectively connected taxable income from such business. Further, in certain cases where a Form W-9 has not been received, the rules under section 1446 require a partnership to presume that a partner is a foreign person, and pay the section 1446 withholding tax. Therefore, if you are a U.S. person that is a partner in a partnership conducting a trade or business in the United States, provide Form W-9 to the partnership to establish your U.S. status and avoid section 1446 withholding on your share of partnership income.")]), _c('p', [_vm._v("In the cases below, the following person must give Form W-9 to the partnership for purposes of establishing its U.S. status and avoiding withholding on its allocable share of net income from the partnership conducting a trade or business in the United States.")]), _c('ul', [_c('li', [_vm._v("In the case of a disregarded entity with a U.S. owner, the U.S. owner of the disregarded entity and not the entity;")]), _c('li', [_vm._v("In the case of a grantor trust with a U.S. grantor or other U.S. owner, generally, the U.S. grantor or other U.S. owner of the grantor trust and not the trust; and")]), _c('li', [_vm._v("In the case of a U.S. trust (other than a grantor trust), the U.S. trust (other than a grantor trust) and not the beneficiaries of the trust. ")])]), _c('p', [_c('b', [_vm._v("Foreign person.")]), _vm._v(" If you are a foreign person or the U.S. branch of a foreign bank that has elected to be treated as a U.S. person, do not use Form W-9. Instead, use the appropriate Form W-8 or Form 8233 (see Pub. 515, Withholding of Tax on Nonresident Aliens and Foreign Entities).")]), _c('p', [_c('b', [_vm._v("Nonresident alien who becomes a resident alien.")]), _vm._v("Generally, only a nonresident alien individual may use the terms of a tax treaty to reduce or eliminate U.S. tax on certain types of income. However, most tax treaties contain a provision known as a “saving clause.” Exceptions specified in the saving clause may permit an exemption from tax to continue for certain types of income even after the payee has otherwise become a U.S. resident alien for tax purposes.")]), _c('p', [_vm._v(" If you are a U.S. resident alien who is relying on an exception contained in the saving clause of a tax treaty to claim an exemption from U.S. tax on certain types of income, you must attach a statement to Form W-9 that specifies the following five items. "), _c('ol', [_c('li', [_vm._v("The treaty country. Generally, this must be the same treaty under which you claimed exemption from tax as a nonresident alien.")]), _c('li', [_vm._v("The treaty article addressing the income.")]), _c('li', [_vm._v("The article number (or location) in the tax treaty that contains the saving clause and its exceptions.")]), _c('li', [_vm._v("The type and amount of income that qualifies for the exemption from tax.")]), _c('li', [_vm._v("Sufficient facts to justify the exemption from tax under the terms of the treaty article.")])])]), _c('p', [_c('b', [_vm._v("Example.")]), _vm._v("Article 20 of the U.S.-China income tax treaty allows an exemption from tax for scholarship income received by a Chinese student temporarily present in the United States. Under U.S. law, this student will become a resident alien for tax purposes if his or her stay in the United States exceeds 5 calendar years. However, paragraph 2 of the first Protocol to the U.S.-China treaty (dated April 30, 1984) allows the provisions of Article 20 to continue to apply even after the Chinese student becomes a resident alien of the United States. A Chinese student who qualifies for this exception (under paragraph 2 of the first protocol) and is relying on this exception to claim an exemption from tax on his or her scholarship or fellowship income would attach to Form W-9 a statement that includes the information described above to support that exemption.")]), _c('p', [_vm._v("If you are a nonresident alien or a foreign entity, give the requester the appropriate completed Form W-8 or Form 8233.")])])], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-3",
      modifiers: {
        "accordion-3": true
      }
    }],
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    },
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Backup Withholding ")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-3",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('b-card-text', {
    staticStyle: {
      "height": "190px",
      "overflow-y": "scroll"
    }
  }, [_c('h2', [_vm._v("Backup Withholding")]), _c('p', [_c('b', [_vm._v("What is backup withholding?")]), _vm._v("Persons making certain payments to you must under certain conditions withhold and pay to the IRS 24% of such payments. This is called “backup withholding.” Payments that may be subject to backup withholding include interest, tax-exempt interest, dividends, broker and barter exchange transactions, rents, royalties, nonemployee pay, payments made in settlement of payment card and third party network transactions, and certain payments from fishing boat operators. Real estate transactions are not subject to backup withholding.")]), _c('p', [_vm._v("You will not be subject to backup withholding on payments you receive if you give the requester your correct TIN, make the proper certifications, and report all your taxable interest and dividends on your tax return."), _c('br'), _c('b', [_vm._v("Payments you receive will be subject to backup withholding if:")]), _c('ol', [_c('li', [_vm._v("You do not furnish your TIN to the requester,")]), _c('li', [_vm._v("You do not certify your TIN when required (see the instructions for Part II for details),")]), _c('li', [_vm._v("The IRS tells the requester that you furnished an incorrect TIN,")]), _c('li', [_vm._v("The IRS tells you that you are subject to backup withholding because you did not report all your interest and dividends on your tax return (for reportable interest and dividends only), or")]), _c('li', [_vm._v("You do not certify to the requester that you are not subject to backup withholding under 4 above (for reportable interest and dividend accounts opened after 1983 only).")])])]), _c('p', [_vm._v("Certain payees and payments are exempt from backup withholding. See Exempt payee code, later, and the separate Instructions for the Requester of Form W-9 for more information.")]), _c('p', [_vm._v("Also see "), _c('i', [_vm._v("Special rules for partnerships,")]), _vm._v(" earlier.")])])], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-4",
      modifiers: {
        "accordion-4": true
      }
    }],
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    },
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("FATCA Reporting ")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-4",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('b-card-text', [_c('h2', [_vm._v("What is FATCA Reporting?")]), _c('p', [_vm._v("The Foreign Account Tax Compliance Act (FATCA) requires a participating foreign financial institution to report all United States account holders that are specified United States persons. Certain payees are exempt from FATCA reporting. See Exemption from FATCA reporting code, later, and the Instructions for the Requester of Form W-9 for more information.")])])], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-5",
      modifiers: {
        "accordion-5": true
      }
    }],
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    },
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Update Information ")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-5",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('b-card-text', {
    staticStyle: {
      "height": "190px",
      "overflow-y": "auto"
    }
  }, [_c('h2', [_vm._v("Updating Your Information")]), _c('p', [_vm._v("You must provide updated information to any person to whom you claimed to be an exempt payee if you are no longer an exempt payee and anticipate receiving reportable payments in the future from this person. For example, you may need to provide updated information if you are a C corporation that elects to be an S corporation, or if you no longer are tax exempt. In addition, you must furnish a new Form W-9 if the name or TIN changes for the account; for example, if the grantor of a grantor trust dies.")])])], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-6",
      modifiers: {
        "accordion-6": true
      }
    }],
    staticStyle: {
      "text-align": "left",
      "font-size": "18px"
    },
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Penalties ")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-6",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('b-card-text', {
    staticStyle: {
      "height": "190px",
      "overflow-y": "auto"
    }
  }, [_c('h2', [_vm._v("Penalties")]), _c('p', [_c('b', [_vm._v("Failure to furnish TIN.")]), _vm._v(" If you fail to furnish your correct TIN to a requester, you are subject to a penalty of $50 for each such failure unless your failure is due to reasonable cause and not to willful neglect.")]), _c('p', [_c('b', [_vm._v("Civil penalty for false information with respect to withholding.")]), _vm._v("If you make a false statement with no reasonable basis that results in no backup withholding, you are subject to a $500 ")]), _c('p', [_c('b', [_vm._v("Criminal penalty for falsifying information.")]), _vm._v(" Willfully falsifying certifications or affirmations may subject you to criminal penalties including fines and/or imprisonment.")]), _c('p', [_c('b', [_vm._v("Misuse of TINs.")]), _vm._v("If the requester discloses or uses TINs in violation of federal law, the requester may be subject to civil and criminal penalties.")])])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "button_container"
  }, [_c('button', {
    staticClass: "back",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.navigatePrevious
    }
  }, [_vm._v("Back")]), _c('div', {
    staticClass: "button"
  }, [_c('button', {
    staticClass: "next",
    on: {
      "click": _vm.saveGeneralInstruction
    }
  }, [_vm._v("Next")])])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }